"use strict";
import {on, find, findAllIn, findIn, empty, setAttribute} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import asyncAppend from "@elements/async-append";
import axios from "axios";

export function init() {
    onFind('.js-dynamic-tabs', function (container) {
        findAllIn('[data-bs-toggle="tab"]', container).map((element) => {
            on('shown.bs.tab', function () {
                loadContent(element);
            }, element);

            on('dynamic-tabs.reload', function () {
                loadContent(element);
            }, element);
        });
    });
}

function loadContent(element) {
    let target = find(element.getAttribute('href')),
        targetUrl = target.getAttribute('data-content-url');

    if (targetUrl) {
        let pendingRequest = axios({method: 'POST', url: targetUrl });

        asyncAppend({
            target: findAllIn('.js-dynamic-tab__content', target),
            loading: findAllIn('.js-dynamic-tab__loading', target)
        }, pendingRequest.then((x) => x.data));
    }
}